export default {
  saveDashboard(state, dashboard) {
    state.dashboard = dashboard;
  },
};
